import { mapObjIndexed, pickAll, pipe, pathOr } from 'ramda';
import type { LongHeaderBodyFootnote as LongHeaderBodyFootnoteId } from '../models.generated';
import { useLongHeaderBodyFootnoteQuery } from '../queries/contentTypes/longHeaderBodyFootnote.generated';
import type { LongHeaderBodyFootnote } from '../types.generated';

export type LongHeaderBodyFootnoteData = {
  key: string;
  header: string;
  body: string;
  footnote?: string;
  tooltip?: string;
};

export const toLongHeaderBodyFootnoteData = (
  queryResult: LongHeaderBodyFootnote | {},
) => {
  return {
    ...pipe(
      pickAll(['key', 'header', 'body', 'footnote', '__typename']),
      mapObjIndexed(val => val ?? ''),
    )(queryResult),
    tooltip: pathOr('', ['tooltip', 'value'], queryResult),
  } as LongHeaderBodyFootnoteData;
};

const useLongHeaderBodyFootnoteData = (
  id: LongHeaderBodyFootnoteId,
): LongHeaderBodyFootnoteData => {
  const hookResult = useLongHeaderBodyFootnoteQuery({ variables: { id } });
  const queryResult = hookResult?.data?.longHeaderBodyFootnote ?? {};

  return toLongHeaderBodyFootnoteData(queryResult);
};

export default useLongHeaderBodyFootnoteData;
